import { h, Component } from 'preact';

export default class ChatTitleMsg extends Component {

    render({ conf }, {}) {
        const accentColor = conf.mainColor;

        return (
            <div style={{ position: 'relative', cursor: 'pointer', height: '90px' }} onClick={this.props.onClick}>

                {/* Intro message bubble */}
                <div style={{
                    background: '#1a1a2e',
                    color: '#fff',
                    display: 'block',
                    position: 'absolute',
                    fontSize: '13px',
                    lineHeight: '1.5',
                    top: '12px',
                    right: '90px',
                    borderRadius: '12px',
                    borderBottomRightRadius: '4px',
                    padding: '12px 16px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    maxWidth: '220px',
                    fontFamily: "'Inter', -apple-system, sans-serif",
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    {conf.introMessage}
                </div>

                {/* Avatar button */}
                <div style={{
                    background: accentColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '8px',
                    right: '20px',
                    height: '56px',
                    width: '56px',
                    borderRadius: '50%',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                    overflow: 'visible'
                }}>
                    {conf.closedChatAvatarUrl
                        ? <img
                            src={conf.closedChatAvatarUrl}
                            alt="Avatar"
                            style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                          />
                        : <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                            <path d="M20 2H4C2.9 2 2 2.9 2 4v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" fill="#0d0d0d" />
                          </svg>
                    }

                    {/* Notification badge */}
                    <div style={{
                        background: '#ef4444',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        position: 'absolute',
                        right: '-3px',
                        top: '-3px',
                        textAlign: 'center',
                        color: '#fff',
                        fontWeight: '700',
                        fontSize: '10px',
                        lineHeight: '18px',
                        fontFamily: "'Inter', sans-serif",
                        border: '2px solid #fff'
                    }}>
                        1
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widget/chat-title-msg.js